// extracted by mini-css-extract-plugin
export default {"Socials":"Utils_Socials__s+Jhk","Banner":"Utils_Banner__t3pf3","LinkBtn":"Utils_LinkBtn__Z16d2","LinkBtnGreen":"Utils_LinkBtnGreen__rhEJN"};